import Decimal from "decimal.js";
import UnitPrice from "./unit-price";
import EstimateItems from "./estimate-items";

export type EstimateItemId = string;

/**
 * 見積もり項目
 */
export default class EstimateItem {
  private originalUnitPrice: UnitPrice;
  private originalUnitLoss: UnitPrice;

  public constructor(
    public id: EstimateItemId | null = null,
    public unitName: string = "",
    public unitType: string = "",
    unitPrice: UnitPrice = new UnitPrice(0),
    unitLoss: UnitPrice = new UnitPrice(0),
    public amount: Decimal.Value = 0,
    public totalPrice: number,
    public memo: string = "",
    public purchased: boolean = false,
    public purchasedRow: boolean = false,
    public expenseCategoryId: string = "",
    public items: EstimateItems = new EstimateItems(),
    public vendorName: string = "",
    public isEditable: boolean = false,
    public tempUuid: string = "",
    public level: number = 0,
    public isFromActualResult: boolean = false
  ) {
    this.originalUnitPrice = unitPrice;
    this.originalUnitLoss = unitLoss;
  }

  public get unitPrice(): UnitPrice {
    if (this.items.isEmpty()) {
      return this.originalUnitPrice;
    }
    if (this.amount <= 0) {
      return new UnitPrice(0);
    }
    return new UnitPrice(this.items.totalPrice.div(this.amount));
  }

  public set unitPrice(unitPrice: UnitPrice) {
    this.originalUnitPrice = unitPrice;
  }

  public get unitLoss(): UnitPrice {
    if (this.items.isEmpty()) {
      return this.originalUnitLoss;
    }
    if (this.amount <= 0) {
      return new UnitPrice(0);
    }
    return new UnitPrice(this.items.totalLoss.div(this.amount));
  }

  public set unitLoss(unitLoss: UnitPrice) {
    this.originalUnitLoss = unitLoss;
  }

  public get price(): Decimal {
    if (this.items.isEmpty()) {
      return new Decimal(this.unitPrice.items(this.amount));
    }
    return this.items.totalPrice;
  }

  public get loss(): Decimal {
    if (this.items.isEmpty()) {
      return new Decimal(this.unitLoss.items(this.amount));
    }
    return this.items.totalLoss;
  }

  public discount(categoryDiscountIds: string[]): number {
    if (!this.items.isEmpty()) {
      return this.items.totalDiscount(categoryDiscountIds);
    }
    if (categoryDiscountIds.includes(this.expenseCategoryId)) {
      return this.price.toNumber();
    }
    return 0;
  }

  public toJSON(): any {
    return {
      id: this.id,
      amount: this.amount,
      unitName: this.unitName,
      unitType: this.unitType,
      unitPrice: this.unitPrice.toNumber(),
      unitLoss: this.unitLoss.toNumber(),
      totalPrice: this.price.toNumber(),
      loss: this.loss.toNumber(),
      memo: this.memo,
      purchased: this.purchased,
      purchasedRow: this.purchasedRow,
      expenseCategoryId: this.expenseCategoryId,
      items: this.items.toJSON(),
      vendorName: this.vendorName,
      isEditable: this.isEditable,
      tempUuid: this.tempUuid,
      level: this.level,
      isFromActualResult: this.isFromActualResult
    };
  }
}
